import React from 'react'
import FAQbox1 from './Components/FAQ-box1'
import HomeBox13 from './Components/Home-box13'
import FAQHeader from './Components/FAQ-header'
import QNA from './Components/QNA'

function FAQ() {
    return (
        <>
            <FAQHeader />
            <FAQbox1 />
            <QNA />
            <HomeBox13 />
        </>
    )
}

export default FAQ